import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store.types";
import { loadEtlImports as loadEtlImportsUC } from "./useCases/load-imports/loadEtlImports.use-case";
import { LoadUserRequest, loadUsers as loadUsersUC } from "./useCases/load-users/loadUsers.use-case";
import { LoadBrandRequest, loadBrands as loadBrandsUC } from "./useCases/load-brands/loadBrands.use-case";
import { LoadSupplierRequest, loadSuppliers as loadSuppliersUC } from "./useCases/load-suppliers/loadSuppliers.use-case";
import { loadCategories as loadCategoriesUC, LoadCategoryRequest } from "./useCases/load-categories/loadCategories.use-case";
import { loadProducts as loadProductsUC } from "./useCases/load-products/loadProducts.use-case";
import { LoadScheduleTypesRequest, loadScheduleTypes as loadScheduleTypesUC } from "./useCases/load-schedule-types/loadScheduleTypes.use-case";
import { useUpdateSelectedEtlImportMutation } from "etl/core";
import { LoadLaboratoryRequest, loadLaboratories as loadLaboratoriesUC } from "./useCases/load-laboratories/loadLaboratories.use-case";

export const useEtlDataUseCases = () => {
	const dispatch = useDispatch<AppDispatch>();

	const [updateSelectedEtlImport] = useUpdateSelectedEtlImportMutation();

	const loadEtlImports = () => dispatch(loadEtlImportsUC());
	const loadUsers = (args: LoadUserRequest) => dispatch(loadUsersUC(args));
	const loadBrands = (args: LoadBrandRequest) => dispatch(loadBrandsUC(args));
	const loadSuppliers = (args: LoadSupplierRequest) => dispatch(loadSuppliersUC(args));
	const loadCategories = (args: LoadCategoryRequest) => dispatch(loadCategoriesUC(args));
	const loadProducts = () => dispatch(loadProductsUC());
	const loadScheduleTypes = (args: LoadScheduleTypesRequest) => dispatch(loadScheduleTypesUC(args));
	const loadLaboratories = (args: LoadLaboratoryRequest) => dispatch(loadLaboratoriesUC(args));

	return {
		updateSelectedEtlImport,
		loadEtlImports,
		loadUsers,
		loadBrands,
		loadCategories,
		loadSuppliers,
		loadProducts,
		loadScheduleTypes,
		loadLaboratories,
	};
};

export type UseEtlDataUseCases = ReturnType<typeof useEtlDataUseCases>;
